module.exports = __webpack_public_path__ + "static/media/image3.cf88ea71.png";